import { render, staticRenderFns } from "./billingSetup.vue?vue&type=template&id=7dd51121&scoped=true"
import script from "./billingSetup.vue?vue&type=script&lang=js"
export * from "./billingSetup.vue?vue&type=script&lang=js"
import style0 from "./billingSetup.vue?vue&type=style&index=0&id=7dd51121&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd51121",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd51121')) {
      api.createRecord('7dd51121', component.options)
    } else {
      api.reload('7dd51121', component.options)
    }
    module.hot.accept("./billingSetup.vue?vue&type=template&id=7dd51121&scoped=true", function () {
      api.rerender('7dd51121', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/components/billingSetup.vue"
export default component.exports